import { DEFAULT_OTHER_TEXT, PARTY_A } from 'Common/constants';
import MatterPropsJS from 'Common/Utils/MatterProps';

export default owner =>
  owner === MatterPropsJS('self.party', PARTY_A)
    ? 'you'
    : MatterPropsJS('other.firstname', DEFAULT_OTHER_TEXT);
